import { BILIS_colors } from "../values/String"

export function TypographyError({ style, children}) {
    return (
        <p style={{
            color: '#FFF',
            backgroundColor: BILIS_colors.secondary,
            padding: '10px',
            borderRadius: '10px',
            ...style
        }}>
            {children}
        </p>
    )
}
export function TypographyDefault({ children }) {
    return (
        <p style={{
            margin: 0,
            padding: 0
        }}>
            {children}
        </p>)
}
export function TypographyGray({ children }) {
    return (
        <p style={{
            color: 'gray'
        }}>
            {children}
        </p>)
}

export function TyphographyHeader2({ style, children}) {
    return (
        <h2
            style={{
                padding: '20px 0px',
                ...style
            }}
        >
            {children}    
        </h2>
    )
}

export function TyphographyHeader3({ style, children}) {
    return (
        <h3
            style={{
                padding: '30px 0px',
                ...style
            }}
        >
            {children}    
        </h3>
    )
}